import React, { createContext, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Appointment from "./components/Appointment/Appointment/Appointment";
import Home from "./components/Home/Home/Home";
import Notfound from "./components/NotFound/Notfound";
import Login from "./components/Login/Login";
import DashboardAppointments from "./components/DashBoard/DashboardAppointments/DashboardAppointments";
import Dashboard from "./components/DashBoard/Dashboard/Dashboard";
import Patients from "./components/DashBoard/Patients/Patients";
import Prescriptions from "./components/DashBoard/Prescriptions/Prescriptions";
import AddDoctor from "./components/DashBoard/AddDoctor/AddDoctor";


export const UserContext = createContext();

function App() {
  const [loggedInUser, setLoggedInUser] = useState({});
  return (
    <UserContext.Provider value={[loggedInUser, setLoggedInUser]}>
      {/* <h1>{loggedInUser.email}</h1> */}
      <Router>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/appointment">
            <Appointment></Appointment>
          </Route>
          
          <Route path="/dashboard/appointments">
            <DashboardAppointments></DashboardAppointments>
          </Route>
          <Route path="/dashboard/patients">
            <Patients></Patients>
          </Route>
          <Route path="/dashboard/prescriptions">
            <Prescriptions></Prescriptions>
          </Route>
          <Route path="/dashboard/addDoctor">
            <AddDoctor></AddDoctor>
          </Route>
          <Route exact path="/dashboard">
            <Dashboard></Dashboard>
          </Route>
          <Route path="/login">
            <Login></Login>
          </Route>
          <Route path="*">
            <Notfound></Notfound>
          </Route>
        </Switch>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
